import React, {useState, useRef, useEffect, useLayoutEffect} from 'react';
import Select from 'react-select';
import './Input.scss';
//import {Button} from 'react-bootstrap';

import {ReactComponent as Chevron} from '../../assets/image/chevron_down.svg';

//import {IMaskInput} from 'react-imask';

const Input = (props) => {
    let {
        className="",
        elementType="text",
        label,
        defaultValue = "",
        changed,
        hideLabel=false,
        placeholder='Choisir...',
        options = [{ value:'',label:'Fournir des choix.'}],
        //mask='',
        append=false,
        prepend=false,
        checked=false,
        ...rest
    } = props;
    const selectInstanceIdRef = useRef(null);
    if (selectInstanceIdRef.current === null) {
        selectInstanceIdRef.current = `pix-${Math.random().toString(36).slice(2, 11)}`;
    }
    const selectTriggerRef = useRef(null);
    var value = false;
    if(props.value){
        value = props.value;
    }
    //console.log(value);
    var addedClasses = '';
    //delete props.append;
    const [elementValue,setElementValue] = useState(defaultValue);
    const [elementChecked,setElementChecked] = useState(checked);
    const [elementStatus,setElementStatus] = useState('normal');
    var onChangeFunction = changed;
    if(!onChangeFunction && elementType === 'checkbox'){
        onChangeFunction = (e) => {
            setElementChecked(e.target.checked);
            setIsOpen(false);
        }
    }else if(!onChangeFunction){
        onChangeFunction = (e) => {
            setElementValue(e.target.value);
            setIsOpen(false);
        }
    }
    if(elementType === 'checkbox'){
        if(!checked === elementChecked){
            setElementChecked(checked);
        }
    }
    var InputElement = null;
    //SELECT ELEMENTS
    const [isOpen,setIsOpen] = useState(false);
    //const [lock,setLock] = useState(false);
    const selectInputRef = useRef();

    useLayoutEffect(() => {
        if (elementType !== 'select' || !isOpen) return;
        const rs = selectInputRef.current;
        if (rs && typeof rs.focus === 'function') {
            rs.focus();
        }
    }, [elementType, isOpen]);

    useEffect(() => {
        if (elementType !== 'select' || !isOpen) return undefined;
        const onDocKeyDown = (e) => {
            if (e.key === 'Escape') {
                setIsOpen(false);
                selectTriggerRef.current?.focus();
            }
        };
        document.addEventListener('keydown', onDocKeyDown, true);
        return () => document.removeEventListener('keydown', onDocKeyDown, true);
    }, [elementType, isOpen]);

    //SWITCH DES ÉLÉMENTS
    switch (elementType){
        case 'textarea':
            InputElement = (
                <textarea 
                    onChange={onChangeFunction}
                    value={elementValue}
                    {...rest}
                >{elementValue}</textarea>
            )
            break;
        case 'select':
            var outputValue = '';
            //console.log(selectInputRef.current.select.getValue())
            if(Array.isArray(value)){
               value.forEach(el=>{
                    if(outputValue!==''){outputValue+=', ';}
                    outputValue+=el.label;
                })
            }
            //console.log(options);
            //console.log(options[0]);
            var selectClass = '';
            //console.log(options);
            if(options){
                const isMulti = !!rest.isMulti;
                const selectRSValue = isMulti
                    ? (Array.isArray(props.value) ? props.value : [])
                    : ((props.value === false || props.value === null || props.value === undefined || props.value === '')
                        ? null
                        : props.value);
                const sid = selectInstanceIdRef.current;
                const selectLabelId = `${sid}-lbl`;
                const selectValueId = `${sid}-val`;
                const handleOpenerKeyDown = (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setIsOpen((open) => !open);
                    } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                        if (!isOpen) {
                            e.preventDefault();
                            setIsOpen(true);
                        }
                    }
                };
                const openerAriaLabelledBy = !hideLabel && label
                    ? `${selectLabelId} ${selectValueId}`
                    : undefined;
                const openerAriaLabel = hideLabel || !label
                    ? (outputValue || placeholder)
                    : undefined;
                InputElement = (
                    <div className={"SelectContainer "+selectClass}>
                        <span id={selectValueId} className="sr-only">
                            {outputValue ? `Sélection : ${outputValue}` : placeholder}
                        </span>
                        <button
                            type="button"
                            className="opener"
                            ref={selectTriggerRef}
                            aria-haspopup="listbox"
                            aria-expanded={isOpen}
                            {...(openerAriaLabelledBy ? { 'aria-labelledby': openerAriaLabelledBy } : {})}
                            {...(openerAriaLabel ? { 'aria-label': openerAriaLabel } : {})}
                            onClick={() => { setIsOpen((open) => !open); }}
                            onKeyDown={handleOpenerKeyDown}
                        >
                            <div aria-hidden="true">{outputValue ? outputValue : placeholder}</div>
                            <Chevron aria-hidden="true" />
                        </button>
                        {isOpen &&
                            <div className="clickOutCatcher" onClick={() => { setIsOpen(false); }}></div>
                        }
                        {isOpen &&
                            <Select 
                                ref={selectInputRef}
                                instanceId={selectInstanceIdRef.current}
                                onMenuClose={() => { setIsOpen(false); }}
                                onChange={onChangeFunction}
                                value={selectRSValue}
                                options={options}
                                autoFocus
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={false}
                                hideSelectedOptions={false}
                                menuIsOpen
                                noOptionsMessage={()=>{return "Aucun résultat";}}
                                placeholder="Rechercher"
                                classNamePrefix="pix-react-select"
                                maxMenuHeight={200}
                                isClearable={false}
                                {...rest}
                                aria-label={label || 'Liste de choix'}
                                //style={{width:"100%"}}
                            /> 
                        }
                    </div>
                )
            }
                addedClasses += ' is-select';
                break;
        /*case 'mask':
            InputElement = (
                <IMaskInput 
                    mask={mask}
                    value={elementValue}
                    onChange={onChangeFunction}
                    onPaste={onChangeFunction}
                    {...rest}
                />
            )
            break;*/
        case 'checkbox':
            InputElement = (
                <input 
                    value={elementValue}
                    type="checkbox"
                    onChange={onChangeFunction}
                    checked={elementChecked}
                    {...rest}
                />
            );
            addedClasses += '';
            //console.log(elementChecked);
            if(elementChecked){
                addedClasses += ' is-checked';
            }
            break;
        case 'text' :
            if(elementStatus === 'focused'){
                addedClasses += ' is-filled';
            }
            InputElement = (
                <input 
                    value={elementValue}
                    type={elementType}
                    onChange={onChangeFunction}
                    onFocus={(e)=>{setElementStatus('focused')}}
                    onBlur={(e)=>{setElementStatus('normal')}}
                    {...rest}
                />
            )
            break;
        default :
            InputElement = (
                <input 
                    value={elementValue}
                    type={elementType}
                    onChange={onChangeFunction}
                    {...rest}
                />
            )
            break;
    }
    addedClasses += ' is-'+elementType;
    if(elementValue){
        addedClasses += ' is-filled';
    }
    var classesGroup="";
    if(prepend || append){
        classesGroup+=' input-group';
    }
    if(prepend){
        classesGroup+=' has-prepend';
    }
    if(append){
        classesGroup+=' has-append';
    }
    if (elementType === 'checkbox' && !hideLabel) {
        return (
            <div className={"Input " + className + ' ' + addedClasses}>
                <label className="Input-checkboxLabel">
                    {InputElement}
                    <div className="label">{label}</div>
                </label>
            </div>
        );
    }
    if (elementType === 'select' && !hideLabel) {
        const selectLabelDomId = `${selectInstanceIdRef.current}-lbl`;
        return (
            <div className={"Input " + className + ' ' + addedClasses}>
                <div className="label" id={selectLabelDomId}>{label}</div>
                <div className={classesGroup}>
                    {prepend &&
                        <div className="input-group-prepend">
                            {prepend}
                        </div>
                    }
                    {InputElement}
                    {append &&
                        <div className="input-group-append">
                            {append}
                        </div>
                    }
                </div>
            </div>
        );
    }
    return (
        <div className={"Input " + className + ' ' + addedClasses}>
            {!hideLabel ?
                <label>
                    <div className="label">{label}</div>
                    <div className={classesGroup}>
                        {prepend && 
                            <div className="input-group-prepend">
                                {prepend}
                            </div>
                        }
                        {InputElement}
                        {append && 
                            <div className="input-group-append">
                                {append}
                            </div>
                        }
                    </div>
                </label>
            :
                <div className={classesGroup}>
                    {prepend && 
                        <div className="input-group-prepend">
                            {prepend}
                        </div>
                    }
                    {InputElement}
                    {append && 
                        <div className="input-group-append">
                            {append}
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default Input;